import fp from 'lodash/fp';
import { isBusinessAdmin, isBusinessUser, isExternalUser, isManager, isTeamManager } from '../services';
import { routes } from './routes';
import { shouldDisplayEvents } from '../containers/pages/onboarding/industry';

const navLinks = (props) => [
  {
    title: 'CPD',
    route: routes.app.training.home,
    icon: 'training-large',
    shouldDisplay: () => props.user.roleAssignments
  },
  {
    title: 'Events',
    route: routes.app.training.eventHome,
    icon: 'training-large',
    shouldDisplay: () => props.user.roleAssignments
      && !isManager(props.user)
      && shouldDisplayEvents(props.industry)
      && fp.get('searchTiles.length')(props.dashboardEvent) > 0
  },
  {
    title: 'Tasks',
    route: routes.app.tasks.home,
    icon: 'training-large',
    notification: (props.taskCount > 0) ? props.taskCount : null,
    shouldDisplay: () => isBusinessAdmin(props.user) || isBusinessUser(props.user) || isExternalUser(props.user)
  },
  {
    title: 'Teams',
    route: routes.app.teams.root,
    icon: 'team-large',
    notification: props.pendingExternalCpdCount,
    shouldDisplay: () => isBusinessAdmin(props.user) || isTeamManager(props.user, props.business)
  }
]

export default navLinks;



// WEBPACK FOOTER //
// ./src/constants/nav-links.js